import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'react-jss'
import classNames from 'classnames'

import styles from './confirmation-item-style'

const ConfirmationItem = props =>
  <p className={classNames(props.classes.confirmationItem, props.className)}>
    <span className={classNames('fal', props.isPending ? 'fa-clock'  : 'fa-check-circle', props.classes.confirmationItemIcon, { [props.classes.confirmationItemIconPending]: !!props.isPending })} />
    {props.children}
  </p>

ConfirmationItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isPending: PropTypes.bool,
}

export default withStyles(styles)(ConfirmationItem)
